"use client";
import { api } from "@/lib/api/api";
import { useQuery } from "@tanstack/react-query";

export function usePermissions(resourceIds: string[]) {
  const {
    data: permissions,
    isLoading,
    isError,
    refetch: refetchPermissions
  } = useQuery({
    queryKey: ["organizations.resourceScheduledPermissionsAll", resourceIds],

    queryFn: async () => {
      const res =
        await api.client.organizations.resourceScheduledPermissionsAll(
          resourceIds
        );
      return res.result;
    }
  });

  const {
    data: additionalAccess,
    isLoading: isAdditionalLoading,
    isError: isAdditionalError,
    refetch: refetchAdditionalAccess
  } = useQuery({
    queryKey: ["organizations.getResourceAdditionalAccess", resourceIds],

    queryFn: async () => {
      const multiple = resourceIds.map(
        async (resId) =>
          (await api.client.organizations.getResourceAdditionalAccess(resId))
            .result ?? []
      );
      return Promise.all(multiple);
    }
  });

  const refresh = async () => {
    await refetchPermissions();
    await refetchAdditionalAccess();
  };

  const loading =
    !isLoading && !isError && !isAdditionalLoading && !isAdditionalError;
  return {
    refresh,
    permissions,
    additionalAccess,
    isError,
    loading,
    resourceIds
  };
}
